import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Flex, useMediaQuery, useTheme } from '@chakra-ui/react';
import _ from 'lodash';
import Image from '@rsc/ui-components/tailwind/Image';
import { motion, useScroll, useTransform } from 'framer-motion';

function useParallax(value, distance = 0) {
  return useTransform(value, [0, 1], [-distance, distance]);
}

function ImageReel({ images, initialImageIndex, inverseAnimation, ...props }) {
  const theme = useTheme();
  const [isLgScreen] = useMediaQuery(`(min-width: ${theme.breakpoints.lg})`, {
    ssr: true,
  });

  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref });

  const parallax = useParallax(
    scrollYProgress,
    isLgScreen && (inverseAnimation ? -600 : 1800)
  );

  const mobileParallax = useParallax(
    scrollYProgress,
    !isLgScreen && (inverseAnimation ? -100 : 200)
  );

  const continuosImages = Array(3).fill(images).flat();

  return (
    <Flex
      ref={ref}
      as={motion.div}
      style={{
        y: parallax,
        x: mobileParallax,
      }}
      left={{
        base: '-20%',
        lg: '0%',
      }}
      flexDir={{ base: 'row', lg: 'column' }}
      w="full"
      gap={4}
      position="relative"
      {...props}
    >
      {continuosImages.map(image => (
        <Image
          className="w-[7.5rem] rounded-md lg:w-full"
          key={_.uniqueId(image.asset?._id)}
          sanityImage={image}
          sanityRole="presentation"
          srcSetBasisWidth={300}
        />
      ))}
    </Flex>
  );
}

ImageReel.defaultProps = {
  initialImageIndex: 0,
  inverseAnimation: false,
};

ImageReel.propTypes = {
  images: PropTypes.arrayOf(PropTypes.shape({}).isRequired).isRequired,
  initialImageIndex: PropTypes.number,
  inverseAnimation: PropTypes.bool,
};

export default ImageReel;
